import React, { useCallback } from 'react'
import styled, { css } from 'styled-components'

import { useLocation } from 'react-router-dom'
import { GAHelper } from 'core/ga'
import { GA_EVENT } from 'core/ga/enums'
import { getLocation, layoutSmall, requestBridge } from 'core/util/default'
import { BRIDGE } from 'core/constants/bridge'
import { useRecoilValue } from 'recoil'
import { STORE_ROOT_PROPS } from 'core/store/global'
import { getUA } from 'core/singleton'
import { CUSTOM_CLASS_NAME } from 'core/constants'

interface CurationProps {
  title: string
  thumbnail: string
  id: string
  partnerId?: string
}

const Curation: React.FC<CurationProps> = (props) => {
  const { title, thumbnail, id, partnerId } = props
  const { isSDK } = getUA()
  const root = useRecoilValue(STORE_ROOT_PROPS)
  const location = useLocation()

  const onClick = useCallback(() => {
    new GAHelper().sendEvent(GA_EVENT.CLICK_CATEGORY, {
      partnersId: partnerId,
      location: getLocation(location),
    })

    if (root?.bridge || window[BRIDGE.CURATION] || isSDK) {
      requestBridge(BRIDGE.CURATION, {
        curationId: id,
      })
    }

    const el = document.getElementById(id)
    if (el) {
      window.scrollTo(0, el?.offsetTop)
    }
  }, [id, location, partnerId, root?.bridge, isSDK])

  return (
    <StyledCuration className={`${CUSTOM_CLASS_NAME.CURATION_CATEGORY_BUTTON}`} onClick={onClick}>
      <div className="curation_wrapper">
        <div className="curation_img">
          <img src={thumbnail} alt={title} />
        </div>
      </div>
      <div className="curation_title">{title}</div>
    </StyledCuration>
  )
}

const StyledCuration = styled.button`
  display: block;
  border: none;
  background: transparent;
  cursor: pointer;
  .curation_img {
    width: 78px;
    height: 78px;
    border-radius: 50%;
    border: solid 1px ${({ theme }) => theme.thumbnailLineColor};
    overflow: hidden;
    img {
      width: inherit;
      height: inherit;
    }
  }
  .curation_title {
    margin-top: 8px;
    width: 78px;
    min-height: 18px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.29;
    text-align: center;
    word-break: break-word;
    color: ${({ theme }) => theme.font.primary};
  }

  ${layoutSmall(css`
    .curation_img {
      width: 72px;
      height: 72px;
    }
    .curation_title {
      width: 72px;
    }
  `)}
`
export default Curation
